"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const CarouselItem = _ref => {
  let {
    id,
    children,
    className = "fadeIn animated overlay overlay-show overlay-op-8",
    backgroundImage,
    ...rest
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    id: id,
    className: "carousel-item-1 " + className,
    style: {
      backgroundImage: "url(".concat(backgroundImage, ")"),
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: "670px"
    },
    ...rest,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "container position-relative z-index-3 h-100",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "row justify-content-center align-items-center h-100",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "col-lg-12",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "d-flex flex-column align-items-center",
            children: children
          })
        })
      })
    })
  });
};

/* Carousel.propTypes = {
  id: PropTypes.string.isRequired,
  colorInvert: PropTypes.bool,
}; */
var _default = exports.default = CarouselItem;